import {
  PageHeader,
  Loading,
  toastSuccessMessage,
  updateUserCurrentStep,
  downloadFileFromResponse,
} from "wup-module1-base";
import { useNavigate } from "react-router-dom";
import SiteQuestions from "../SiteQuestions/SiteQuestions";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Form, Card, Row, Col, Button, Container } from "react-bootstrap";
import { useState, useContext, useEffect, useRef, useCallback } from "react";
import {
  PageTitleConstants,
  ProcessStatusEnum,
  QuestionnairesEnum,
  RoutePathConstants,
} from "../../Constants";
import UserContext from "../../Contexts/UserContext";
import { SurveyService } from "../../Services";

function CompletingBalanceSheetOfModuleFirst() {
  const [surveyData, setSurveyData] = useState(null);
  const { user, setUser } = useContext(UserContext);
  const [surveyAnswersData, setSurveyAnswersData] = useState(null);
  const [isFinal, setIsFinal] = useState(false);
  const saveDataWithIntervalsRef = useRef();
  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    reset,
    trigger,
    unregister,
    watch,
    setError,
    clearErrors,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [answers, setAnswers] = useState({});
  const [surveyId, setSurveyId] = useState(null);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [userCurrentPage, setUserCurrentPage] = useState(1);
  const [areasHelper, setAreasHelper] = useState();
  const survType = QuestionnairesEnum.Module1.value;
  const [isSubmitAvailable, setIsSubmitAvailable] = useState(false);

  function onSubmit() {
    if (!!!isSubmitAvailable) return;
    setIsSubmitLoading(true);
    const rawAnswersObj = {
      tasks: JSON.stringify(areasHelper)
    }
    const requestData = {
      questionnaire_id: surveyId,
      client_id: user.id,
      answers: JSON.stringify(setNewIndexForTable(getValues())),
      final: true,
      complete_answers: getAnswersCount().toString(),
      complete_pages: userCurrentPage.toString(),
      raw_answers_data: JSON.stringify(rawAnswersObj),
    };

    SurveyService.storeSurvey(requestData, user.id, surveyId)
      .then((response) => {
        const updatedUser = updateUserCurrentStep(
          user,
          response.data.client_status
        );
        setUser(updatedUser);
        toastSuccessMessage("Dane przesłane pomyślnie");
        scrollToTop();
        navigate(`/store`);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsSubmitLoading(false);
      });
  }

  //funkcja skrolująca na górę ekranu
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const fetchData = () => {
    SurveyService.fetchSurvey(surveyId)
      .then((response) => {
        setSurveyData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //funkcja pobierająca pdf
  const downloadFeedbackPDF = () => {
    SurveyService.downloadFeedback(user.id)
      .then((res) => {
        downloadFileFromResponse(res);
        toastSuccessMessage("Pobieranie pliku");
      })
      .catch((error) => {
        toast.error("Błąd pobrania PDF");
      });
  };

  //funkcja zwracajaca na ile pytan uzytkownik udzielil odpowiedzi
  const getAnswersCount = () => {
    let answeredQuestions = 0;
    let answeredQuestionIds = new Set();
    let data = getValues();
    for (const key in data) {
      if (key.includes("_")) {
        const questionId = key.split("_")[0];
        if (!answeredQuestionIds.has(questionId) && data[key] !== "") {
          answeredQuestions++;
          answeredQuestionIds.add(questionId);
        }
      }
    }
    for (const key in data) {
      if (!key.includes("_") && data[key] !== "") {
        answeredQuestions++;
      }
    }

    return answeredQuestions;
  };

  //pomocnicza funkcja reindeksująca tworząca jedną tablice dla tabel która wstawiamy do odpowiedzi
  function setDataToUpdate(data) {
    let table = [];
    for (let key in data) {
      for (let subKey in data[key]) {
        let index = subKey;
        let valueKeys = Object.keys(data[key][subKey]);
        for (let i = 0; i < valueKeys.length; i++) {
          let valueKey = valueKeys[i];
          let parts = valueKey.split("_");
          parts[parts.length - 1] = index;
          let newKey = parts.join("_");
          data[key][subKey][newKey] = data[key][subKey][valueKey];
          if (newKey !== valueKey) {
            delete data[key][subKey][valueKey];
          }
        }
        table.push(data[key][subKey]);
      }
    }

    const obj = table.reduce((acc, curr) => {
      return { ...acc, ...curr };
    }, {});

    return obj;
  }

  function moveAnswersToTableFields(data) {
    for (const key in data) {
      if (key.startsWith("answer_")) {
        const fieldKey = key.replace("answer_", "");
        data[fieldKey] = data[key];
        delete data[key];
      }
    }
    return data;
  }

  function setNewIndexForTable(data) {
    data = moveAnswersToTableFields(data);
    for (const key in data) {
      if (key.endsWith("table_0")) {
        delete data[key];
      }
    }

    const groupedData = {};

    for (const key in data) {
      if (key.split("_").length === 3) {
        const [selector, , lastIndexValue] = key.split("_");
        groupedData[selector] = groupedData[selector] || {};
        groupedData[selector][lastIndexValue] = {
          ...groupedData[selector][lastIndexValue],
          [key]: data[key],
        };
        delete data[key];
      }
    }

    const reindexedObject = {};

    for (const [key, value] of Object.entries(groupedData)) {
      reindexedObject[key] = {};
      let index = 1;
      for (const innerValue of Object.values(value)) {
        reindexedObject[key][index] = innerValue;
        index++;
      }
    }
    const updatedData = setDataToUpdate(reindexedObject);

    return { ...data, ...updatedData };
  }

 const saveDataWithIntervals = useCallback(() => {
    const rawAnswersObj = {
      tasks: JSON.stringify(areasHelper)
    };
    const requestData = {
      questionnaire_id: surveyId,
      client_id: user.id,
      answers: JSON.stringify(setNewIndexForTable(getValues())),
      final: false,
      complete_answers: getAnswersCount().toString(),
      complete_pages: userCurrentPage.toString(),
      raw_answers_data: JSON.stringify(rawAnswersObj),
    };
    SurveyService.storeSurvey(requestData, user.id, surveyId)
      .then((response) => {
      })
      .catch((error) => {
        console.error(error);
      });
  }, [areasHelper, surveyId, user.id, getValues, getAnswersCount, userCurrentPage, SurveyService]);

      useEffect(() => {
        saveDataWithIntervalsRef.current = saveDataWithIntervals;
      }, [saveDataWithIntervals]);

  const fetchAnswersData = () => {
    SurveyService.fetchAnswers(user.id, surveyId)
      .then((response) => {
        setAnswers(JSON.parse(response?.data?.answers));
        setSurveyAnswersData(response.data.answers);
        if (!!response.data.final) {
          scrollToTop();
          navigate(`/store`);
          setIsFinal(response.data.final);
        }
        if (!!response.data.complete_pages) {
          setUserCurrentPage(parseInt(response.data.complete_pages));
        } else {
          setUserCurrentPage(1);
        }
      })
      .catch((error) => {
        setUserCurrentPage(1);
        saveDataWithIntervalsRef.current();
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    reset(JSON.parse(surveyAnswersData));
  }, [surveyAnswersData]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      saveDataWithIntervalsRef.current();
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (!isFinal && surveyId != null) {
      const interval = setInterval(() => {
        saveDataWithIntervalsRef.current();
      }, 60000);

      return () => clearInterval(interval);
    }
  }, [isFinal, surveyId, userCurrentPage]);

  useEffect(() => {
    if (surveyId) fetchData();
  }, [surveyId]);

  useEffect(() => {
    if (surveyData) fetchAnswersData();
  }, [surveyData]);

  useEffect(() => {
    SurveyService.fetchTypes()
      .then((response) => {
        const survey = response.data.find(
          (s) => s.type === QuestionnairesEnum.Module1.value
        );
        if (!!survey) setSurveyId(survey.id);
      })
      .catch((error) => {});
  }, []);

  return (
    <>
      <Container>
        <PageHeader
          content={PageTitleConstants.CompletingBalanceSheetOfModuleFirst}
        />
        <Form onSubmit={handleSubmit(onSubmit)}>
          {!!isLoading || !userCurrentPage ? (
            <Loading />
          ) : (
            surveyData && (
              <Row className="mt-1">
                <SiteQuestions
                  surveyArray={surveyData.pages}
                  register={register}
                  getValues={getValues}
                  answers={answers}
                  setAnswers={setAnswers}
                  errors={errors}
                  unregister={unregister}
                  watch={watch}
                  setValue={setValue}
                  surveyAnswersData={surveyAnswersData}
                  isFinal={isFinal}
                  trigger={trigger}
                  isValid={isValid}
                  setUserCurrentPage={setUserCurrentPage}
                  userCurrentPage={userCurrentPage}
                  setError={setError}
                  clearErrors={clearErrors}
                  saveDataWithIntervals={saveDataWithIntervalsRef.current}
                  downloadFeedbackPDF={downloadFeedbackPDF}
                  reset={reset}
                  survType={survType}
                  isSubmitLoading={isSubmitLoading}
                  setAreasHelper={setAreasHelper}
                  isSubmitAvailable={isSubmitAvailable}
                  setIsSubmitAvailable={setIsSubmitAvailable}
                />
              </Row>
            )
          )}
        </Form>
      </Container>
    </>
  );
}

export default CompletingBalanceSheetOfModuleFirst;
